// @ts-nocheck
export interface StatusColorTheme {
    textColorToken: string;
    backgroundColorToken: string;
    borderColorToken: string;
}

const blueTheme: StatusColorTheme = {
    textColorToken: "info.main",
    backgroundColorToken: "info.lightest",
    borderColorToken: "info.light",
};

// Fallback color for unmapped statuses (info/blue)
export const fallbackStatusColorTheme: StatusColorTheme = blueTheme;

const greenTheme: StatusColorTheme = {
    textColorToken: "success.main",
    backgroundColorToken: "success.lightest",
    borderColorToken: "success.light",
};

const orangeTheme: StatusColorTheme = {
    textColorToken: "warning.main",
    backgroundColorToken: "warning.lightest",
    borderColorToken: "warning.light",
};

const redTheme: StatusColorTheme = {
    textColorToken: "danger.main",
    backgroundColorToken: "danger.lightest",
    borderColorToken: "danger.light",
};

// Keyed by raw order.status (Order Status Mapping)
export const orderStatusColorMap: Record<string, StatusColorTheme> = {
    Approved: greenTheme,
    "In process": greenTheme,
    "In Process": greenTheme,
    Closed: greenTheme,
    Free: orangeTheme,
    Blocked: orangeTheme,
    Canceled: redTheme,
    Invoicing: blueTheme,
    Shipping: blueTheme,
};

// Keyed by raw shipment.deliveryStatus (SystemListValue - Shipment Status)
export const shipmentStatusColorMap: Record<string, StatusColorTheme> = {
    Default: greenTheme, // Confirmed
    Delivered: greenTheme, // Delivered
    "Delivered No Tracking": greenTheme, // Delivered No Tracking
    "Ready for Customer Pick Up": blueTheme, // Ready for Customer Pickup
    "Carrier Confirmed Delivery": blueTheme, // Carrier Confirmed ETA
    "In-Transit": blueTheme, // In Transit
};

// Keyed by raw invoice.status (Invoice Status Mapping)
export const invoiceStatusColorMap: Record<string, StatusColorTheme> = {
    Paid: greenTheme,
    PartiallyPaid: orangeTheme,
    NotPaid: blueTheme,
    Overdue: redTheme,
};

export function getStatusColorTheme(
    status: string | undefined | null,
    colorMap: Record<string, StatusColorTheme>,
): StatusColorTheme {
    if (!status) {
        return fallbackStatusColorTheme;
    }

    return colorMap[status] ?? fallbackStatusColorTheme;
}
